<template>
  <div class="divider"></div>
</template>
<script>
export default {};
</script>
<style lang="scss">
.divider {
  height: 0.5px;
  width: 100%;
  background-color: #e0e0e0;
  margin: 12px 0;
}
</style>
